import EducativeModel from './EducativeModel';

export default EducativeModel;